import React from 'react'

// Wraps React.lazy so that a failed dynamic import — the classic "chunk load
// error" that happens when a tab was opened before a new deploy removed the old
// content-hashed chunk — triggers a single full-page reload to fetch the fresh
// index.html and its new chunk set, instead of crashing into the ErrorBoundary.
//
// A sessionStorage flag guards against reload loops: we reload at most once per
// failure, and clear the flag on the next successful import so a later deploy
// can recover again. Keep import paths WITHOUT file extensions (see CLAUDE.md).
const RELOAD_FLAG = 'spa-chunk-reload'

export default function lazyWithRetry(importFn) {
  return React.lazy(async () => {
    try {
      const module = await importFn()
      // Successful load — allow a fresh recovery attempt on the next deploy.
      window.sessionStorage.removeItem(RELOAD_FLAG)
      return module
    } catch (error) {
      const alreadyReloaded = window.sessionStorage.getItem(RELOAD_FLAG)
      if (!alreadyReloaded) {
        window.sessionStorage.setItem(RELOAD_FLAG, '1')
        window.location.reload()
        // Never resolve — the reload replaces this document before React renders.
        return new Promise(() => {})
      }
      // Reloaded once already and still failing — surface the real error.
      throw error
    }
  })
}
